import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';

import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { Store } from '@ngxs/store';

import { UiIconsModule } from 'ui-icons';

import { environment } from '@client/environments/environment';

import { CookieSettingsService } from '../../../shared/core/cookies-settings/services/cookie-settings.service';
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { ExploreLinkCreatorService } from '../../../shared/services/explore-link-creator.service';
import { RouterLinkCreatorService } from '../../../shared/services/router-link-creator.service';
import { AppState } from '../../../shared/state/app.state';
import { ANALYTICS_ACTIONS_DICT, ANALYTICS_CATEGORY_DICT } from '../../../shared/utils/analytics-actions-dict';

@Component({
  selector: 'sh-footer-business',
  imports: [
    CommonModule,
    RouterModule,
    TranslocoPipe,
    UiIconsModule
  ],
  templateUrl: './footer-business.component.html',
  styleUrl: './footer-business.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterBusinessComponent implements OnInit {
  readonly routerLinkCreatorService = inject(RouterLinkCreatorService);
  readonly exploreLinkCreatorService = inject(ExploreLinkCreatorService);
  readonly #translocoService = inject(TranslocoService);
  readonly #store = inject(Store);
  readonly #analytics = inject(AnalyticsService);
  readonly #cookieSettingsService = inject(CookieSettingsService);

  readonly appVersion = environment.app_version;

  termsOfUseLanguage$: Observable<string> | undefined;
  isUserSHAdmin$ = this.#store.select(AppState.isUserSHAdmin);

  ngOnInit() {
    this.termsOfUseLanguage$ = this.#translocoService.langChanges$.pipe(
      startWith('en'),
      map(lang => (lang === 'sk' ? 'SK' : 'EN'))
    );
  }

  triggerCookieSettings(): void {
    this.#cookieSettingsService.unsetAgreeCookie();
  }

  onSocialLinkClick(actionName: keyof typeof ANALYTICS_ACTIONS_DICT): void {
    this.#analytics.sendEvent(ANALYTICS_CATEGORY_DICT.SOCIAL, ANALYTICS_ACTIONS_DICT[actionName]);
  }
}
